import { render, staticRenderFns } from "./alt-card-list.vue?vue&type=template&id=34405c02&scoped=true&"
import script from "./alt-card-list.ts?vue&type=script&lang=ts&"
export * from "./alt-card-list.ts?vue&type=script&lang=ts&"
import style0 from "./alt-card-list.vue?vue&type=style&index=0&id=34405c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34405c02",
  null
  
)

export default component.exports